import React, { useState } from 'react';
import {
  Box,
  Tabs,
  Tab
} from '@mui/material';
import {
  Folder as FolderIcon,
  Settings as SettingsIcon,
  Checklist as ChecklistIcon
} from '@mui/icons-material';
import ProfileTab from './tabs/ProfileTab';
import ConfigTab from './tabs/ConfigTab';
import CriteriaTab from './tabs/CriteriaTab';

/**
 * ToolsPanel - Right panel with tools for building resume
 * 
 * Tabs:
 * - Profile: Browse and add profile items
 * - Config: Reorder items and settings
 * - Criteria: Requirements with coverage indicators
 */
const ToolsPanel = ({
  profile,
  selectedItems,
  resumeConfig,
  onUpdateConfig,
  jobDescription,
  graphData,
  onToggleSelection
}) => {
  const [currentTab, setCurrentTab] = useState('profile');

  return (
    <Box>
      {/* Tab Headers */}
      <Tabs
        value={currentTab}
        onChange={(e, newValue) => setCurrentTab(newValue)}
        variant="fullWidth"
        sx={{ borderBottom: 1, borderColor: 'divider' }}
      >
        <Tab
          value="profile"
          label="Profile"
          icon={<FolderIcon />}
          iconPosition="start"
        />
        <Tab
          value="config"
          label="Config"
          icon={<SettingsIcon />}
          iconPosition="start"
        />
        <Tab
          value="criteria"
          label="Criteria"
          icon={<ChecklistIcon />}
          iconPosition="start"
        />
      </Tabs>

      {/* Tab Content */}
      <Box sx={{ p: 2 }}>
        {currentTab === 'profile' && (
          <ProfileTab
            profile={profile}
            selectedItems={selectedItems}
            graphData={graphData}
            onToggleSelection={onToggleSelection}
          />
        )}
        {currentTab === 'config' && (
          <ConfigTab
            selectedItems={selectedItems}
            resumeConfig={resumeConfig}
            onUpdateConfig={onUpdateConfig}
            onToggleSelection={onToggleSelection}
          />
        )}
        {currentTab === 'criteria' && (
          <CriteriaTab
            jobDescription={jobDescription}
            selectedItems={selectedItems}
            graphData={graphData}
            onToggleSelection={onToggleSelection}
          />
        )}
      </Box>
    </Box>
  );
};

export default ToolsPanel;
